<transfer-searchbox [travel]="sboxData" *ngIf="showSbox"></transfer-searchbox>
<div *ngIf="emptyState">
  <empty-state [emptyState]="emptyState"></empty-state>
</div>
<div
  class="eva-3-container results-container -eva-3-pt-lg"
  *ngIf="responseLoaded && !emptyState"
>
  <agency-mode-button
    [product]="getProduct()"
    [flow]="getFlow()"
    [locale]="getLocale()"
    *ngIf="isAgencyModeAvailable"
  >
  </agency-mode-button>

  <div
    id="redemption-switch-placeholder"
    class="-eva-3-bc-white"
    [ngClass]="{ '-eva-3-hide': !isLoyaltyEnabled }"
  ></div>

  <banner
    *ngIf="banners?.headBanner"
    [bannerData]="banners.headBanner"
    [destinationCity]="destinationCity"
  ></banner>

  <div
    class="eva-3-row -no-gutter"
    [ngClass]="isMobile ? '-eva-3-mt-lg' : '-eva-3-mt-xxlg'"
  >
    <div class="col -sm-12">
      <transfers-map
        [travel]="searchResponse.travel"
        [staticMaps]="searchResponse.staticMaps"
      ></transfers-map>
    </div>
  </div>

  <banner
    class="banner-top"
    *ngIf="banners?.topBanner"
    [bannerData]="banners.topBanner"
    [destinationCity]="destinationCity"
  ></banner>

  <div
    *ngIf="message.title"
    class="eva-3-row -no-gutter"
    [ngClass]="isMobile ? '-eva-3-mt-lg' : '-eva-3-mt-xxlg'"
  >
    <div class="col -sm-12">
      <message [message]="message"> </message>
    </div>
  </div>

  <div
    class="eva-3-row -eva-3-valign"
    [ngClass]="isMobile ? '-eva-3-mt-lg' : '-eva-3-mt-xxlg'"
  >
    <div class="col -sm-12 -md-8">
      <tab-filter
        [tabs]="searchResponse.types"
        [currencies]="searchResponse.currencies.values"
        (tabSelected)="changeTabFilter($event)"
      ></tab-filter>
    </div>
    <div *ngIf="showCurrencySelector" class="col -md-4 -eva-3-fr" role="main">
      <currency-filter 
        [currencies]="searchResponse.currencies.values"
      ></currency-filter>
    </div>
  </div>

  <div
    *ngIf="searchResponse?.items?.length > 0"
    class="eva-3-row clusters-container"
    [ngClass]="isMobile ? '-eva-3-mt-lg' : '-eva-3-mt-xxlg'"
  >
    <div
      class="col -sm-12"
      *ngFor="
        let transfer of searchResponse.items
          | transferFilter : tabFilterSelection;
        first as firstCluster;
        let i = index
      "
      [style.order]="i"
    >
      <transfer-cluster
        [item]="transfer"
        [favoriteHighlight]="firstCluster && isFavoriteHighlighted"
        [highHeavyHighlight]="
          firstCluster &&
          validateHighHeavyHighlight(transfer) &&
          !isFavoriteHighlighted
        "
        [currencies]="searchResponse.currencies.values"
        [loyaltyMode]="loyaltyMode"
        [order]="i"
        [cityGid]="cityGid"
        [bimonetary]="searchResponse.bimonetaryContext"
      ></transfer-cluster>

      <div
        class="col -sm-12 -eva-3-mb-lg clusterBanner"
        *ngIf="
          banners && banners.clusterBanners.length
            ? getNextBanner(i)
            : false as banner
        "
      >
        <banner
          [bannerData]="banner.banner"
          [style.order]="banner.order"
        ></banner>
      </div>
    </div>

  </div>
</div>
<modals-container></modals-container>